import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-book-registration-ledger-report',
  templateUrl: './book-registration-ledger-report.component.html',
  styleUrl: './book-registration-ledger-report.component.scss'
})
export class BookRegistrationLedgerReportComponent {
  filterData: any[] = [];

  startDate!: string;
  endDate!: string;
  repName: string[] = [];
  officeRepName: string[] = [];
  bookName: string[] = [];
  bookSellerName: string[] = [];
  reportType: any;
  currentDate = new Date();

  /* ===== TOTALS ===== */
  TotalSaleCopies = 0;
  TotalReturnCopies = 0;
  TotalComplimentary = 0;
  TotalNetAmount = 0;        // Total of Net Amount column
  TotalShippingCharges = 0;  // Total of Shipping Charges column
  TotalAmount = 0;           // Total of Total Amount (Net + Shipping)
  TotalReceipt = 0;
  TotalCredit = 0;
  TotalPending = 0;
  TotalCommission = 0;
  selectedCommissionFilter: string[] = [];
  selectedComplimentaryFilter: string[] = [];

  constructor(
    private dialogRef: MatDialogRef<BookRegistrationLedgerReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {}

  ngOnInit(): void {
    debugger
    this.startDate = this.data?.startDate;
    this.endDate = this.data?.endDate;
    this.reportType = this.data?.reportType;

    this.repName = this.data?.rep_name || [];
    this.officeRepName = this.data?.office_rep_name || [];
    this.bookName = this.data?.book_name || [];
    this.bookSellerName = this.data?.book_seller_name || [];

    this.selectedCommissionFilter = this.data?.commissionFilter || [];
    this.selectedComplimentaryFilter = this.data?.complimentaryFilter || [];

    console.log('DIALOG DATA:', this.data);

    this.getLedgerReport();
  }

  /* ================= CONVERT TO INT ================= */
  ConvertToInt(value: any): number {
    return Number(value) || 0;
  }

  /* ================= API CALL ================= */
  getLedgerReport(): void {
    const req = {
      start_date: this.startDate,
      end_date: this.endDate,
      rep_name: this.repName,
      office_rep_name: this.officeRepName,
      book_name: this.bookName,
      book_seller_name: this.bookSellerName,
      commissionFilter: this.selectedCommissionFilter,
      complimentaryFilter: this.selectedComplimentaryFilter
    };

    console.log('FINAL PAYLOAD:', req);

    this.service.getBookRegistrationLedgerReport4(req).subscribe({
      next: (res: any) => {
        if (!res || res.success !== true) {
          this.resetData();
          return;
        }

        // Add totalAmount calculation for each row
        this.filterData = (res.records || []).map((d: any) => ({
          ...d,
          totalAmount: this.ConvertToInt(d.total) + this.ConvertToInt(d.shipping_charges)
        }));

        const s = res.summary || {};
        this.TotalSaleCopies = s.totalBookCopies || 0;
        this.TotalReturnCopies = s.totalReturnCopies || 0;
        this.TotalComplimentary = s.totalCompCopies || 0;
        
        // Calculate totals
        this.TotalNetAmount = this.filterData.reduce(
          (sum, d) => sum + this.ConvertToInt(d.total),
          0
        );
        this.TotalShippingCharges = this.filterData.reduce(
          (sum, d) => sum + this.ConvertToInt(d.shipping_charges),
          0
        );
        this.TotalAmount = this.filterData.reduce(
          (sum, d) => sum + d.totalAmount,
          0
        );
        
        this.TotalReceipt = s.totalReceived || 0;
        this.TotalCredit = s.totalCredit || 0;
        this.TotalPending = s.totalPending || 0;
        this.TotalCommission = s.totalCommission || 0;
      },
      error: () => this.resetData()
    });
  }

  /* ================= RESET ================= */
  resetData(): void {
    this.filterData = [];
    this.TotalSaleCopies = 0;
    this.TotalReturnCopies = 0;
    this.TotalComplimentary = 0;
    this.TotalNetAmount = 0;
    this.TotalShippingCharges = 0;
    this.TotalAmount = 0;
    this.TotalReceipt = 0;
    this.TotalCredit = 0;
    this.TotalPending = 0;
    this.TotalCommission = 0;
  }

  /* ================= PRINT ================= */
printPage4(): void {
  const printContent = document.getElementById('print-section');
  if (!printContent) return;

  const WindowPrt = window.open('', '', 'width=1600,height=1000');

  WindowPrt!.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Book Registration Ledger Report</title>
        <style>

          /* ===== FORCE PRINT COLORS ===== */
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
            box-sizing: border-box;
          }

          /* ===== A3 LANDSCAPE ===== */
          @page {
            size: A3 landscape;
            margin: 8mm;
          }

          body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
            font-size: 10px;
            color: #000;
          }

          /* ===== WRAPPER ===== */
          #print-section {
            width: 99%;
            margin: 0 auto;
          }

          /* ===== TABLE ===== */
          table {
            width: 100%;
            border-collapse: collapse;
          }

          th, td {
            border: 1px solid #000;
            padding: 3px 5px;
            vertical-align: middle;
            white-space: nowrap;
          }

          /* ===== RESPECT HTML ALIGNMENT ===== */
          .text-end {
            text-align: right !important;
          }

          .text-start {
            text-align: left !important;
          }

          .text-center {
            text-align: center !important;
          }

          thead {
            display: table-header-group;
          }

          tfoot {
            display: table-row-group;
          }

          tr {
            page-break-inside: avoid;
          }

          /* ===== PRINT ONLY ===== */
          @media print {
            .noPrint {
              display: none !important;
            }

            html, body {
              width: 100%;
              height: auto;
            }
          }

        </style>
      </head>

      <body>
        ${printContent.innerHTML}
      </body>
    </html>
  `);

  WindowPrt!.document.close();
  WindowPrt!.focus();

  setTimeout(() => {
    WindowPrt!.print();
    WindowPrt!.close();
  }, 700);
}




  /* ================= EXCEL ================= */
  exportExcel(fileName: string): void {
    const element = document.getElementById('print-section');
    if (!element) return;

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Ledger');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }

  close(): void {
    this.dialogRef.close();
  }
}